import './Dropdown.scss'

const DropdownComponent = (props) => {
  return (
    <div className="custom-dropdown">
      <div className="label">{props.label}</div>
      <div className="dropdown">
        <button
          className="btn btn-outlined-primary dropdown-toggle"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {props.title}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          {!!props.items
            ? props.items.map((data, i) => (
                <li key={i} onClick={() => props.onClick(data.year)}>
                  {data.year == 0 ? (
                    <p className="dropdown-item">Semua</p>
                  ) : (
                    <p className="dropdown-item">{data.year}</p>
                  )}
                </li>
              ))
            : ''}
        </ul>
      </div>
    </div>
  )
}

export default DropdownComponent
